import { Button, css, FormControlLabel, IconButton, Menu, MenuItem, Stack, Switch, Typography } from '@mui/material';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InvertColorsIcon from '@mui/icons-material/InvertColors';

import { useSeismicStore } from '../stores/useSeismicStore';
import { SeismicColorbarSelect } from './SeismicColorbarSelect';
import { Colorbar } from '../utils/colorbarUtils';

const imageStyle = css({
    height: '20px',
    width: '20px',
    borderRadius: '3px',
});

const containerStyle = css({
    '& .MuiFormControl-root': {
        margin: '0px',
        '& .MuiOutlinedInput-notchedOutline': {
            '& legend': {
                width: '0px',
            }
        }
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: 'white',
            borderWidth: '1px',
            borderRadius: '5px'
        }
    }
});
export function SeismicColorbarNavbar ({setOpenedLegendColorbar, openedLegendColorbar = false}:Props){
    const { setColorbar, colorbar, surveyMetadata } = useSeismicStore(state => ({
        colorbar: state.colorbar,
        setColorbar: state.setColorbar,
        surveyMetadata: state.surveyMetadata,
    }));

    const [isInverted, setIsInverted] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [ isPanelVisible, setIsPanelVisible ] = useState(false);
    const handleClose = () => setIsPanelVisible(false);

    const { t } = useTranslation();
    const iconButtonRef = useRef(null);

    const handleContextMenu = (event: React.MouseEvent) => {
        event.preventDefault();
        setIsPanelVisible(true);
        setAnchorEl(iconButtonRef.current);
    };

    const classNameLabelColorbar = (isPanelVisible) ? 'active': '';
    const classNamePolarity = (isInverted) ? 'active': '';

    useEffect(() => {
        if (isInverted) {
            const invertedColorbar = {...colorbar};
            invertedColorbar.Name = invertedColorbar.Name + '_r';
            setColorbar(invertedColorbar);
        } else {
            const originalColorBar = {...colorbar};
            originalColorBar.Name = originalColorBar.Name.replace('_r', '');
            setColorbar(originalColorBar);
        }
    }, [isInverted]);

    useEffect(() => {
        if (!colorbar.Name.includes('_r') && isInverted){
            setIsInverted(false);
        }
    }, [colorbar?.Name]);

    const additionalColorbars = useMemo(() => {
        return surveyMetadata?.IsVelocity ? [Colorbar.JET] : [];
    }, [surveyMetadata]);

    useEffect(() => {
        surveyMetadata?.IsVelocity && setColorbar(Colorbar.JET);
    }, [surveyMetadata]);

    //onClick={() => /*setOpenedLabelColorbar(!openedLabelColorbar)*/ null}
    return  <Fragment>
        <IconButton style={{width: '38px', display: 'flex', alignItems: 'center'}} id='colorbar' title={t('colorbar')} className={classNameLabelColorbar} ref={iconButtonRef} onClick={handleContextMenu} >
            <img src={colorbar.Picture} css={imageStyle}/>
        </IconButton>
        <IconButton id='colorbar_inv' title={'Invert color polarity'} size='medium' className={classNamePolarity} onClick={() => setIsInverted(!isInverted)} style={{fontSize: '22px'}} >
            <InvertColorsIcon style={{fontSize: '22px', color: 'white'}}></InvertColorsIcon>
        </IconButton>
        <Menu
            keepMounted
            anchorEl={anchorEl}
            open={isPanelVisible}
            onClose={handleClose}
        >
            {/*<MenuItem style={{backgroundColor: 'grey', margin:0}}>
                <Typography>{t('colorbar')}</Typography>
            </MenuItem>*/}
            <MenuItem css={containerStyle}>
                <SeismicColorbarSelect colorbar={colorbar} onChange={setColorbar} additionalColorbars={additionalColorbars}/>
            </MenuItem>
            <MenuItem>
                <FormControlLabel
                    label={<Typography color='white' variant='body2'>Legend</Typography>}
                    control={<Switch checked={openedLegendColorbar} onChange={(event, checked) => setOpenedLegendColorbar && setOpenedLegendColorbar(checked)}/>}
                />
            </MenuItem>
        </Menu>
    </Fragment>;
}

interface Props {
    setOpenedLegendColorbar?: (value: boolean) => void,
    openedLegendColorbar?: boolean,
}